import { BloombergMarketDataRequest } from 'marketData/MarketDataRequest';
import { BarData, TickData } from 'marketData/store/marketDataSlice';

export type TickDataReceivedHandler = (data: TickData[]) => void;
export type BarDataReceivedHandler = (data: BarData[]) => void;

export type RefDataReceivedHandlerOptions = {
    bbSymbol: string;
    startTradingHoursTimestamp: number;
    endTradingHoursTimestamp: number;
    averageVolume: number;
    pnc: number;
};
export type RefDataReceivedHandler = (
    options: RefDataReceivedHandlerOptions
) => void;

export interface ExternalMarketDataStrategy {
    subscribe(request: BloombergMarketDataRequest): void;
    unsubscribe(request: BloombergMarketDataRequest): void;
    onMarketBarDataReceived(handler: BarDataReceivedHandler): void;
    onMarketTickDataReceived(handler: TickDataReceivedHandler): void;
    onRefDataReceived(handler: RefDataReceivedHandler): void;
}

export abstract class ExternalMarketDataStrategyBase
    implements ExternalMarketDataStrategy
{
    protected onMarketBarDataReceivedHandler:
        | BarDataReceivedHandler
        | undefined = undefined;

    protected onRefDataReceivedHandler: RefDataReceivedHandler | undefined =
        undefined;
    protected onMarketTickDataReceivedHandler:
        | TickDataReceivedHandler
        | undefined = undefined;

    public abstract subscribe(request: BloombergMarketDataRequest): void;

    public abstract unsubscribe(request: BloombergMarketDataRequest): void;

    public onMarketBarDataReceived(handler: BarDataReceivedHandler): void {
        this.onMarketBarDataReceivedHandler = handler;
    }
    public onMarketTickDataReceived(handler: TickDataReceivedHandler): void {
        this.onMarketTickDataReceivedHandler = handler;
    }
    public onRefDataReceived(handler: RefDataReceivedHandler): void {
        this.onRefDataReceivedHandler = handler;
    }
}

export class NullExternalMarketDataStrategy
    implements ExternalMarketDataStrategy
{
    public subscribe(): void {
        return;
    }

    public unsubscribe(): void {
        return;
    }

    public onMarketBarDataReceived() {
        return;
    }

    public onRefDataReceived() {
        return;
    }

    public onMarketTickDataReceived() {
        return;
    }
}
